var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm:px-6 lg:px-8"},[_c('div',{staticClass:"h-full bg-white shadow-2xl"},[_c('user-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }